// main.js

// header lisence text
/*!
 * Copyright (c) 2019 Aboc Co.,Ltd. All rights reserved.
 *
 * This source code or any portion thereof must not be
 * reproduced or used in any manner whatsoever.
 */

// app scss
import './assets/styles.scss';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// gtm datalayer init
window.dataLayer = window.dataLayer || [];

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
